import Navbar from './Navbar';
import MobileNav from './MobileNav';

const Header = () => {
  return (
    <>
      {/* <Navbar /> */}
      <MobileNav />
    </>
  );
};

export default Header;